import { render, staticRenderFns } from "./AssociadoModule.vue?vue&type=template&id=fad8abaa"
import script from "./AssociadoModule.vue?vue&type=script&lang=js"
export * from "./AssociadoModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports